export default __webpack_public_path__ + "static/media/template_pro__0012_15---SamGreenwood.f27d8602.png";